import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, ArrowUpRight } from 'lucide-react';

export default function Footer({ onNav }) {
  return (
    <footer className="bg-obsidian text-bone py-24 md:py-32" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <button
          onClick={() => onNav('contact')}
          className="serif italic text-[16vw] md:text-[12vw] leading-none tracking-tighter block text-left hover:text-signal transition-colors duration-500"
          data-testid="footer-lets-talk"
        >
          Let's talk.
        </button>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-10 font-sans text-sm">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-bone/40 mb-4">Contact</div>
            <a
              href="mailto:meet@raufmedia.com"
              className="flex items-center gap-2 hover:text-signal transition-colors duration-300 mb-3"
              data-testid="footer-email"
            >
              <Mail size={14} /> meet@raufmedia.com
            </a>
            <a
              href="tel:+16043689865"
              className="flex items-center gap-2 hover:text-signal transition-colors duration-300"
              data-testid="footer-phone"
            >
              <Phone size={14} /> +1 604 368 9865
            </a>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-bone/40 mb-4">Navigate</div>
            <div className="flex flex-col gap-2">
              {['services', 'values', 'portfolio', 'process'].map((id) => (
                <button
                  key={id}
                  onClick={() => onNav(id)}
                  className="text-left capitalize hover:text-signal transition-colors duration-300"
                >
                  {id}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-bone/40 mb-4">Social</div>
            <div className="flex flex-col gap-2">
              {['Instagram', 'LinkedIn', 'Dribbble', 'X / Twitter'].map((s) => (
                <a
                  key={s}
                  href="#"
                  className="flex items-center gap-1 hover:text-signal transition-colors duration-300"
                >
                  {s} <ArrowUpRight size={12} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-bone/40 mb-4">Studio</div>
            <p className="text-bone/70">Remote-first, worldwide.<br />Fast delivery, honest work.</p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-bone/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-bone/40 font-sans">
          <span>© {new Date().getFullYear()} 13150259 Canada Inc. — operating as RaufMedia. All rights reserved.</span>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-bone transition-colors duration-300" data-testid="footer-privacy">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-bone transition-colors duration-300" data-testid="footer-terms">
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
